import React, { useEffect, useState } from "react";
import { Select, DatePicker, Typography, Tag, Space } from "antd";
import dayjs from "dayjs";
import isoWeek from "dayjs/plugin/isoWeek";
import Cookies from "js-cookie";

dayjs.extend(isoWeek);

const TimesheetHeader = ({
  users,
  selectedUser,
  setSelectedUser,
  weekRef,
  setWeekRef,
  timesheetMap,
  setDeletedTimesheetIds
}) => {
  const [statusCounts, setStatusCounts] = useState({
    Draft: 0,
    Pending: 0,
    Approved: 0,
    Rejected: 0,
  });

  useEffect(() => {
    const currUserId = Cookies.get("userId");
    console.log('Current User ID from cookies:', currUserId);
    console.log('Users list:', users);
    if (currUserId && users.length > 0 && !selectedUser) {
      setSelectedUser(currUserId);
    }
    if (!weekRef) {
      const todayIsoMonday = dayjs().startOf("isoWeek");
      setWeekRef(todayIsoMonday);
    }
    
  }, [users]);

  useEffect(() => {
    if (!timesheetMap) {
      setStatusCounts({ Draft: 0, Pending: 0, Approved: 0, Rejected: 0 });
      return;
    }
  
    const counts = { Draft: 0, Pending: 0, Approved: 0, Rejected: 0 };
  
    Object.values(timesheetMap).forEach(ts => {
      let status = ts.status || "Draft";
  
      // Normalize backend statuses to match counter keys
      if (status === "Pending Approval") status = "Pending";
      if (status === "Approved") status = "Approved";
      if (status === "Rejected") status = "Rejected";
      if (status === "Draft") status = "Draft";
  
      if (counts[status] !== undefined) counts[status]++;
    });
  
    setStatusCounts(counts);
  }, [timesheetMap]);
  

  const tagStyle = {
    padding: "2px 8px",
    fontSize: 12,
    borderRadius: 6,
    lineHeight: 1.5,
  };

  const countStyle = {
    marginLeft: 4,
    fontWeight: 600,
  };

  const handleWeekChange = (date) => {
    setDeletedTimesheetIds([]);
    if (!date) return;
  
    let selected = date;
  
    // Fix: If the selected day is Saturday, use previous day (Friday) to determine the week
    // Because default Monday calculation jumps to next week for Saturday.
    if (selected.day() === 6) {
      selected = selected.subtract(1, "day");
    }
  
    const monday = selected.startOf("week").day(1); // Monday of the correct week
  
    setWeekRef(monday);
  };
  

  return (
    <div
      style={{
        background: "#fff",
        padding: "10px 16px",
        borderRadius: 8,
        boxShadow: "0 2px 4px rgba(0,0,0,0.08)",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        flexWrap: "wrap",
        gap: 12,
      }}
    >
      {/* LEFT SIDE: Title */}
      <Typography.Title
        level={5}
        style={{ margin: 0, color: "#1890ff", fontWeight: 600 }}
      >
        Timesheet Entry
      </Typography.Title>

      {/* RIGHT SIDE: Status Tags + User + Week Picker */}
      <Space size="middle" align="center" wrap>
        <Space size="small" wrap align="center">
          <Tag color="blue" style={tagStyle}>
            Draft <span style={countStyle}>{statusCounts.Draft}</span>
          </Tag>
          <Tag color="orange" style={tagStyle}>
            Pending Approval <span style={countStyle}>{statusCounts.Pending}</span>
          </Tag>
          <Tag color="green" style={tagStyle}>
            Approved <span style={countStyle}>{statusCounts.Approved}</span>
          </Tag>
          <Tag color="red" style={tagStyle}>
            Rejected <span style={countStyle}>{statusCounts.Rejected}</span>
          </Tag>
        </Space>

        <div style={{ display: "flex", alignItems: "center", gap: 6 }}>
          <Typography.Text strong>User</Typography.Text>
          <Select
            placeholder="Select user"
            value={selectedUser}
            onChange={setSelectedUser}
            style={{ minWidth: 160 }}
            size="small"
            options={users.map((u) => ({ label: u.Name, value: u._id }))}
          />
        </div>

        <div style={{ display: "flex", alignItems: "center", gap: 6 }}>
          <Typography.Text strong>Week</Typography.Text>
          <DatePicker
            picker="week"
            value={weekRef}
            onChange={handleWeekChange}
            style={{ width: 100 }}
            size="small"
            allowClear={false}
            disabledDate={(current) => {
              // Disable all dates AFTER today
              return current && current > dayjs().endOf("day");
            }}          
          />
        </div>
      </Space>
    </div>
  );
};

export default TimesheetHeader;
